import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Spacer, Divider, AvatarGroup, Avatar,
    Menu, MenuButton, MenuList, MenuItem, Drawer, DrawerContent, CloseButton, useDisclosure
} from '@chakra-ui/react';
import { MdLogin, MdLogout, MdGroup, MdPortrait, MdStar, MdLockReset, MdLocalHospital } from 'react-icons/md';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { withNamespaces } from 'react-i18next';

import { apiLoadListCompany } from '../../redux/apis';
import { getCompanyList } from '../../redux/selectors';
import { setSidebarMobileOpen } from '../../redux/actions';
import { getCurrentNavTab, getIsSidebarMobileOpen } from '../../redux/selectors';
import { 
    ACTIVE_HOME_TAB, ACTIVE_DEPARTMENT_TAB, ACTIVE_DOCTOR_TAB, ACTIVE_SCHEDULE_SUCCESSFUL_TAB, ACTIVE_SERVICE_PRICE_TAB, 
    ACTIVE_VIEW_SCHEDULE_TAB, ACTIVE_DISPLAY_PATIENT_RESULT_TAB, ACTIVE_SETTING_TAB
} from '../../redux/constants';
import { SELECTED_CLINIC_MAX_AGE } from '../../constants';
import i18n from "../../i18n";
import SelectWithImage from '../../components/SelectWithImage';

// import Sidebar from '../../components/Sidebar';
// import SelectedClinicModal from './Modals/SelectedClinicModal';
const NATION_FLAGS = [
    {label: "VietNam", value: "vi", icon: "/images/nation_flags/vi.png"},
    {label: "English", value: "en", icon: "/images/nation_flags/en.png"},
]

function Navbar(props) {
    const { currentNavTab, isSidebarMobileOpen, setSidebarMobileOpen } = props;
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic", "makeDoctorAppointmentDatas"]);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const mobileUseDisclosure = useDisclosure();
    const initialRef = useRef(null);
    const mounted = useRef();

    useEffect(() => {
        if(props.companyList?.length > 0) {
            const firstCompany = props.companyList.find(item => item.id === cookies.selectedClinic?.data?.id);
            if(!firstCompany) {
                removeCookie("selectedClinic");
            }
        }
    }, [props.companyList]);

    // useEffect(() => {
    //     if(!mounted.current) {
    //         const getVisitedUser = async() => {
    //             let response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/visited_users`, {
    //                 auth: {
    //                     username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
    //                     password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
    //                 }
    //             });

    //             if(!response.data) {
    //                 await props.apiLoadListCompany({ order_by: "name", order_dir: "ASC" });
    //                 onOpen();
    //             } else {
    //                 // với những user đã từng chọn phòng khám trước đây thì load lại cho họ
    //                 setCookie(
    //                     "selectedClinic", 
    //                     { 
    //                         data: {
    //                             ...response.data.companyDetail,
    //                             systemSettingDetail: response.data.systemSettingDetail
    //                         }
    //                     }, 
    //                     { 
    //                         path: '/', maxAge: SELECTED_CLINIC_MAX_AGE 

    //                     }
    //                 );            
    //             }
    //         }
            
    //         // nếu chưa chọn phòng khám nào thì hiển thị popup để user chọn phòng khám
    //         if(!cookies.selectedClinic?.data?.id) {
    //             getVisitedUser();
    //         }
    //         mounted.current = true;
    //     }
    // });

    return (
        <Box bg="gray.100">
            <SideBar 
                companyList={props.companyList} 
                currentNavTab={currentNavTab}
                initialRef={initialRef}
                isOpen={isOpen}
                onClose={() => mobileUseDisclosure.onClose}
                display={{ base: "none", md: "flex", lg: "flex" }}
                t={props.t}
            />

            <Drawer 
                autoFocus={false}
                // isOpen={mobileUseDisclosure.isOpen}
                isOpen={isSidebarMobileOpen}
                placement="left"
                onClose={mobileUseDisclosure.onClose}
                returnFocusOnClose={false}
                onOverlayClick={mobileUseDisclosure.onClose}
                size="full"
            >
                <DrawerContent>
                    {/* <SideBar onClose={mobileUseDisclosure.onClose}/> */}
                    <SideBar t={props.t} onClose={() => setSidebarMobileOpen(!isSidebarMobileOpen)}/>
                </DrawerContent>
            </Drawer>

            {/* <MinimizeSideBar onOpen={mobileUseDisclosure.onOpen}/> */}
            {/* {
                isOpen &&
                <SelectedClinicModal 
                    initialRef={initialRef} isOpen={isOpen} onClose={onClose}
                    companyList={props.companyList}
                />
            } */}
        </Box>
    )
}

function SideBar({ companyList, currentNavTab, initialRef, isOpen, onClose, t, ...rest }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic"]);
    const navigate = useNavigate();
    const handleChangeLanguage = (value) => {
        console.log("---- handleChangeLanguage", value)
        i18n.changeLanguage(value)
    }

    return (
        <>
            <Flex h={{ base: "20", md: "0", lg: "0" }} alignItems="center" mx="8" justifyContent="space-between" {...rest}>
                <CloseButton display={{ base: "flex", md: "none" }} onClick={onClose} />
            </Flex>
            <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} bg="#37474f" 
                px={{ base: 2, md: 2, lg: 0 }} py={{ base: 2, md: 2, lg: 0 }} alignItems="flex-start" {...rest}
            >
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_HOME_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                    () => {
                        onClose();
                        navigate("/");
                    }
                }>
                    <Text fontSize="16px" fontWeight="700">{t("Make_Doctor_Schedule")}</Text>
                </Button>
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_DEPARTMENT_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                        () => {
                            onClose();
                            navigate("/department");
                        }
                    }
                >
                    <Text fontSize="16px" fontWeight="500">{t("Department_Specialist")}</Text>
                </Button>
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_DOCTOR_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                        () => {
                            onClose();
                            navigate("/doctor");
                        }
                    }
                >
                    <Text fontSize="16px" fontWeight="500">{t("Doctor")}</Text>
                </Button>
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_SERVICE_PRICE_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                        () => {
                            onClose();
                            navigate("/service_prices");
                        }
                    }
                >
                    <Text fontSize="16px" fontWeight="500">{t("Service")}</Text>
                </Button>
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_SCHEDULE_SUCCESSFUL_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                        () => {
                            onClose();
                            navigate("/view_patient_ticket");
                        }
                    }
                >
                    <Text fontSize="16px" fontWeight="500">{t("Schedule_Ticket")}</Text>
                </Button>
                <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_VIEW_SCHEDULE_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }} 
                    onClick={
                        () => {
                            onClose();
                            navigate("/view_schedule");
                        }
                    }
                >
                    <Text fontSize="16px" fontWeight="500">{t("Schedule_Calendar")}</Text>
                </Button>
                {
                    (currentNavTab === ACTIVE_DISPLAY_PATIENT_RESULT_TAB) &&
                    <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_DISPLAY_PATIENT_RESULT_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }}>
                        <Text fontSize="16px" fontWeight="500">{t("Medical_Result")}</Text>
                    </Button>
                }
                {
                    cookies.loginCookie &&
                    <Button color="#FFFFFF" bg={currentNavTab === ACTIVE_SETTING_TAB ? "#00bcd4" : ""} variant="ghost" _hover={{ color: "#ffff00" }}
                        onClick={ 
                            () => {
                                onClose();
                                navigate("/settings");
                            }
                        }
                    >
                        <Text fontSize="16px" fontWeight="500">{t("Setting_Data")}</Text>
                    </Button>
                }

                <Spacer />
                {
                    !(cookies.loginCookie) &&   
                    <Button variant="ghost" color="#FFFFFF" _hover={{ color: "#ffff00" }} className='rotate-text' 
                        onClick={() => {
                            onClose();
                            navigate("/pricing/new");
                        }                       
                    }>
                        <Icon boxSize={5} as={MdStar} color="#ffa000" mr="4px"/> 
                        <Text fontSize="15px" color="#ffa000">
                            {t("Register")}
                        </Text>
                    </Button>
                }
                {
                    !(cookies.loginCookie) &&     
                    <Button colorScheme='green' onClick={() => {
                            onClose();
                            navigate("/login");
                        }
                    }>
                        <Icon boxSize={6} as={MdLogin} mr="8px"/> 
                        <Text fontSize="14px">{t("Login")}</Text>
                    </Button>
                }
                {
                    cookies.loginCookie &&
                    <Menu bg="#007F4E">
                        <MenuButton as={Button} rightIcon={<ChevronDownIcon />} bg="#007F4E" color="#FFFFFF" 
                            _hover={{ bg: "#007F4E", color: "#ffff00" }}
                        >
                            <HStack>
                                <Text color="#ffffff" fontWeight="400">
                                    {
                                        cookies.loginCookie.data?.full_name ? cookies.loginCookie.data?.full_name.slice(0, 25) : "NO NAME"
                                    }
                                </Text>
                                <Avatar name={cookies.loginCookie.data?.full_name} 
                                    src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/users/${cookies.loginCookie.data?.portrait_url}`} 
                                    size="sm" 
                                />
                            </HStack>
                        </MenuButton>
                        <MenuList>
                            <MenuItem onClick={ 
                                    () => {
                                        onClose();
                                        navigate("/clinic_information");
                                    }
                                }
                            >
                                <Icon  boxSize={6} as={MdLocalHospital} marginRight="8px"/>{t("Company_Info")}
                            </MenuItem>
                            <MenuItem onClick={ 
                                    () => {
                                        onClose();
                                        navigate("/user_information");
                                    }
                                }
                            >
                                <Icon  boxSize={6} as={MdPortrait} marginRight="8px"/>{t("Account_Info")}
                            </MenuItem>
                            <MenuItem onClick={ 
                                    () => {
                                        onClose();
                                        navigate("/change_password");
                                    }
                                }
                            >
                                <Icon  boxSize={6} as={MdLockReset} marginRight="8px"/>{t("Change_Password")}
                            </MenuItem>
                            
                            <MenuItem color="red.500" onClick={ 
                                    () => {
                                        onClose();
                                        removeCookie("loginCookie", { path: "/" });
                                        // removeCookie("selectedClinic");
                                        removeCookie("makeDoctorAppointmentDatas");
                                        navigate("/login");
                                    }
                                }
                            >
                                <Icon boxSize={6} as={MdLogout} marginRight="8px"/>{t("Logout")}
                            </MenuItem>
                        </MenuList>
                    </Menu>
                }
                <SelectWithImage id={i18n.language || "en"} datas={NATION_FLAGS} color="#fff" onChange={handleChangeLanguage}/>
                {/* <button onClick={() => i18n.changeLanguage('vi')}>de</button>
                <button onClick={() => i18n.changeLanguage('en')}>en</button> */}
            </Flex>
        </>
    )
}

const mapStateToProps = (state) => {
    const currentNavTab =           getCurrentNavTab(state);
    const isSidebarMobileOpen =     getIsSidebarMobileOpen(state);
    const companyList =             getCompanyList(state);

    return { currentNavTab, isSidebarMobileOpen, companyList };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListCompany:             payload => dispatch(apiLoadListCompany(payload)),
    setSidebarMobileOpen:           payload => dispatch(setSidebarMobileOpen(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Navbar));